import { queryOptions, useQuery } from '@tanstack/react-query';
import type { Paginated, PostListItemDto } from '@zoxo/shared';

import { api } from '../../lib/api';

/**
 * 홈의 커뮤니티 두 칸 — 최신 5건 · 인기글 5건(조회수 순). 랜딩 loader 가 같은 queryOptions 로
 * 캐시를 채운다. 지원사업 네 칸과 같은 규칙: 실패해도 화면을 안 막는다.
 */
export const latestPostsQuery = queryOptions({
  queryKey: ['posts-latest'],
  queryFn: () => api.get<Paginated<PostListItemDto>>('/posts?limit=5').then((p) => p.data),
  staleTime: 5 * 60 * 1000,
});

export const popularPostsQuery = queryOptions({
  queryKey: ['posts-popular'],
  queryFn: () => api.get<Paginated<PostListItemDto>>('/posts?limit=5&sort=popular').then((p) => p.data),
  staleTime: 5 * 60 * 1000,
});

export function useLatestPosts() {
  return useQuery(latestPostsQuery);
}

export function usePopularPosts() {
  return useQuery(popularPostsQuery);
}
